import React from 'react'
import { FaLinkedin } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";
import { FaXTwitter } from "react-icons/fa6";
import { PiReadCvLogoBold } from "react-icons/pi";




const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
           <FaLinkedin onClick={() => window.location.href = 'https://www.linkedin.com/in/malik-ahmad-/'} />

        </div>
        <div>
            <BsGithub onClick={()=> window.location.href = 'https://github.com/ahmiii143'}/>
        </div>
        <div>
            <FaXTwitter onClick={()=> window.location.href = 'https://twitter.com/Ahmii101'}/>
        </div>
        <div>
          <PiReadCvLogoBold  onClick={()=> window.location.href = "https://violet-liv-54.tiiny.site/"}/>

        </div>

    </div>
  )
}

export default SocialMedia

